import component from '@/mixins/component'

import IntersectionManager from '@/js/manager/intersection'

import { sort } from '@/data'

export default {
  name: 'push-post',
  mixins: [component],
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      posts: this.items,
      baseUrl: process.env.VUE_APP_DEV_DIST_URL ? process.env.VUE_APP_DEV_DIST_URL : `${window.location.protocol}//${window.location.hostname}`
    }
  },
  created () {
    if (!this.posts.length) {
      this.$store.getters.get('post').then((posts) => {
        posts = sort(posts, 'date', 'desc')
        this.posts = posts.slice(0, 2)
        this.$nextTick(() => {
          new IntersectionManager(this)
        })
      })
    }
  },
  methods: {
    mouseenter (item) {
      this.$refs[`title${item}`][0].mouseenter()
      this.$refs[`link${item}`][0].mouseenter()
    },
    mouseleave (item) {
      this.$refs[`title${item}`][0].mouseleave()
      this.$refs[`link${item}`][0].mouseleave()
    }
  }

}
